import * as Sentry from '@sentry/angular';

import { EnvironmentEnum } from './app/models/environment-enum';
import { environment } from './environments/environment';

export const sentryInit = (sentryDsn: string) => {
  const envsWhereSentryEnabled: EnvironmentEnum[] = [
    EnvironmentEnum.Demo,
    EnvironmentEnum.Prod,
    EnvironmentEnum.Dev,
    EnvironmentEnum.Staging,
    EnvironmentEnum.Test,
    EnvironmentEnum.DR,
  ];
  const shouldEnableSentry = envsWhereSentryEnabled.includes(environment.name);

  Sentry.init({
    release: environment.appVersion,
    enabled: shouldEnableSentry,
    environment: environment.name,
    dsn: sentryDsn,
    integrations: [
      Sentry.httpClientIntegration({
        failedRequestStatusCodes: [
          // TODO: enable back when attaching response body is supported https://github.com/getsentry/sentry-javascript/issues/12544
          // [400, 499],
          // [500, 599],
        ],
      }),
      Sentry.httpContextIntegration(),
      Sentry.replayIntegration(),
      Sentry.browserTracingIntegration(),
      Sentry.captureConsoleIntegration({
        levels: ['warn', 'error'],
      }),
    ],
    tracesSampleRate: 0.2,
    tracePropagationTargets: [
      /^https:\/\/(?!app-meta\.fxhedgepool\.com\/).*\.fxhedgepool\.com/,
    ],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.5,
  });
};
